import dayjs from 'dayjs'
import { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { Order } from '../interfaces/common/contract'

export const useLastOrder = () => {
  const user = useSelector((state) => state.user)
  const [lastOrder, setLastOrder] = useState<Order | null>(null)

  useEffect(() => {
    if (user?.orders) {
      setLastOrder(
        user?.orders.sort((a, b) =>
          dayjs(b.checkoutCompletedAt).diff(dayjs(a.checkoutCompletedAt))
        )[0]
      )
    }
  }, [user])
  return lastOrder
}
